import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import UIAssetKeys from '../UIAssetKeys';

export default class ConfirmDialog extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene,bgColor, msg, fontsize, callbackListener) {
    super(scene);

    this.cover = this.scene.add.rectangle(0,0,this.scene.scale.width,this.scene.scale.height, 0x000000).setAlpha(0.9)
      .setInteractive()
      .setOrigin(0);
    this.add(this.cover);

    this.boxContainer = this.scene.add.container();

    this.bg = this.scene.add.graphics({ fillStyle: { color: bgColor } });
    this.bg.workingWidth = 600;
    this.bg.workingHeight = 400;
    this.bg.fillRoundedRect(0,0,this.bg.workingWidth, this.bg.workingHeight, 12);
    this.bg.x = this.scene.scale.width / 2 - this.bg.workingWidth / 2;
    this.bg.y = this.scene.scale.height / 2 - this.bg.workingHeight / 2;
    this.boxContainer.add(this.bg);

    this.lblMsg = ABCyaPhaser.Text.addText(this.bg.x + this.bg.workingWidth / 2, this.bg.y + 35, `${fontsize}pt`, 0x000000, FontKeys._BPreplay, msg, this.boxContainer, true).setOrigin(0.5, 0)
      .setWordWrapWidth(500);

    this.btnYes = this.scene.add.container(0,0).setSize(170, 170);
    this.boxContainer.add(this.btnYes);
    const btnYesBg = this.scene.add.circle(0,0,this.btnYes.width / 2, 0xbddd05).setOrigin(0);
    this.btnYes.add(btnYesBg);
    ABCyaPhaser.Container.setContainerInteractive(this.btnYes);
    const btnYesTxt = ABCyaPhaser.Text.addText(btnYesBg.width / 2,btnYesBg.height / 2,62, 0xffffff,FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.buttons.yes_button'), this.btnYes).setPadding(5,5);
    ABCyaPhaser.Buttons.convertToButton(this.btnYes, { onClick: () => this.onClickYes() });

    this.btnYes.x = this.bg.workingWidth / 2 - this.btnYes.width + this.bg.x;
    this.btnYes.y = this.bg.workingHeight - this.btnYes.height - 40 + this.bg.y;

    this.btnNo = this.scene.add.container(0,0).setSize(170, 170);
    this.boxContainer.add(this.btnNo);
    const btnNoBg = this.scene.add.circle(0,0,this.btnNo.width / 2, 0xf75228).setOrigin(0);
    this.btnNo.add(btnNoBg);
    ABCyaPhaser.Container.setContainerInteractive(this.btnNo);
    const btnNoTxt = ABCyaPhaser.Text.addText(btnNoBg.width / 2,btnNoBg.height / 2,62, 0xffffff,FontKeys._BPreplay, ABCyaPhaser.Localization.instance.getLocalizedString('game_screen.buttons.no_button'), this.btnNo);
    ABCyaPhaser.Buttons.convertToButton(this.btnNo, { onClick: () => this.onClickNo() });

    this.btnNo.x = this.bg.workingWidth / 2 + 20 + this.bg.x;
    this.btnNo.y = this.bg.workingHeight - this.btnYes.height - 40 + this.bg.y;

    this.boxContainer.iterate(child => child.setPosition(child.x - this.bg.workingWidth, child.y - this.bg.workingHeight));
    this.boxContainer.x = this.bg.workingWidth;
    this.boxContainer.y = this.bg.workingHeight;
    this.boxContainer.scale = 0;

    ABCyaPhaser.Tweens.addTween(this.boxContainer, 1200, { scale: 1, easeParams: [1, 0.3] }, Phaser.Math.Easing.Elastic.Out);
    this.add(this.boxContainer);

    this.callbackListener = callbackListener;
  }

  onClickYes () {
    this.callbackListener('YES');
  }

  onClickNo () {
    this.callbackListener('NO');
  }
}